import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subject } from 'rxjs';
import { GrupoService } from '../../../services/grupo.service';
import { DeclaracionService } from '../../../services/declaracion.service';
import { EmpresaService } from '../../../services/empresa.service';
import { AnioService } from '../../../services/anio.service';
import { MesService } from '../../../services/mes.service';
import { Anio } from '../../../models/anio';
import { TipodeclaracionService } from '../../../services/tipodeclaracion.service';
import { Declaracion } from '../../../models/declaracion';
import { DataTableDirective } from 'angular-datatables';

@Component({
	selector: 'app-declaraciones',
	templateUrl: './declaraciones.component.html',
	styleUrls: ['./declaraciones.component.css'],
	providers: [GrupoService, DeclaracionService, EmpresaService, AnioService, MesService]
})
export class DeclaracionesComponent implements OnInit {
	public identity;
	public token;
	public status;
	public message_success;
	public message_error;
	public declaraciones: any;
	public declaracion: Declaracion;
	public empresa: any;
	public empresas: any;
	public meses: any = null;
	public anio: Anio;
	public anios: any = null;
	public hoteles: any = null;
	public tipo_declaraciones: any = null;
	public dtOptions: DataTables.Settings = {};
	public dtTrigger: Subject<any> = new Subject();
	public disableBtn: any = false


	@ViewChild(DataTableDirective)
	public dtElement: DataTableDirective;

	constructor(
		private _route: ActivatedRoute,
		private _router: Router,
		private _grupoService: GrupoService,
		private _empresaService: EmpresaService,
		private _tipodeclaracionService: TipodeclaracionService,
		private _anioService: AnioService,
		private _mesService: MesService,
		private _declaracionService: DeclaracionService
	) {
		this.identity = this._grupoService.getIdentity();
		this.token = this._grupoService.getToken();
		this.declaracion = new Declaracion(0, 0, 0, 0, 0, 0, '', 0, '');
		this.anio = new Anio(1, '', 0);
	}

	ngOnInit() {
		this.dtOptions = {
			pagingType: 'full_numbers',
			pageLength: 10
		}
		this.getDeclaraciones();
		this.getEmpresasByUser();
		this.getEmptyHabitaciones();
		//this.getTipoDeclaraciones();
		//this.getAnios();
		//var anio = $("#anio").val();
	}

	getEmptyHabitaciones() {
		this._empresaService.getEmptyHabitaciones(this.token).subscribe(
			response => {
				// Obtener el token 
				if (response.status == 'success') {
					this.hoteles = response.hoteles;

					let array = []

					this.hoteles.forEach(element => {

						if (element.habitaciones == 0) {
							let message = 'La empresa ' + element.nombre_establecimiento + ', no cuenta con el total de habitaciones, este dato es necesario para realizar su declaración, favor de anexarlo en el apartado de "Mis empresas."'
							alert(message)
						}
					});
				}
			},
			error => {
				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				}
			}
		);
	}

	getDeclaraciones() {
		this._declaracionService.getDeclaraciones(this.token).subscribe(
			response => {
				// Obtener el token 
				if (response.status == 'success') {
					this.declaraciones = response.declaraciones;
					this.dtTrigger.next();
				}
			},
			error => {
				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				} else {
					this.declaraciones = null;
				}
			}
		);
	}

	getEmpresasByUser() {
		this._empresaService.getEmpresasByGrupo(this.token).subscribe(
			response => {
				// Obtener el token 
				if (response.status == 'success') {
					this.empresas = response.empresas;
				}
			},
			error => {
				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				} else {
					this.declaraciones = null;
				}
			}
		);
	}

	getTipoDeclaraciones() {

		this.tipo_declaraciones = null;
		this.anios = null;
		this.meses = null;

		this._tipodeclaracionService.getTipoDeclaraciones(this.token).subscribe(
			response => {
				// Obtener el token 
				if (response.status == 'success') {
					this.tipo_declaraciones = response.tipoDeclaraciones;
				}
			},
			error => {
				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				} else {
					this.declaraciones = null;
				}
			}
		);
	}

	getAnios() {
		this._anioService.getAniosHabilitados(this.token).subscribe(
			response => {
				// Obtener el token 
				if (response.status == 'success') {
					this.anios = response.anios;
				}
			},
			error => {
				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				} else {
					this.declaraciones = null;
				}
			}
		);
	}

	getMesesHabilitados() {
		var anio = $("#anio_id").val();
		var empresa_id = $("#empresa_id").val();
		this._mesService.getMesesHabilitados(this.token, anio, empresa_id).subscribe(
			response => {
				if (response.status == 'success') {
					this.meses = response.meses;
				}
			},
			error => {
				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				} else {
					alert('Existe problemas con el servidor, favor de intentar más tarde');
				}
			}
		);
	}

	createDeclaracion() {
		this.disableBtn = true

		var empresa_id = $("#empresa_id").val();
		var tipo_declaracion_id = $("#tipo_declaracion_id").val();
		var anio_id = $("#anio_id").val();
		var mes_id = $("#mes_id").val();
		var ocupacion = $("#ocupacion").val();

		let info = { empresa_id: empresa_id, tipo_declaracion_id: tipo_declaracion_id, anio_id: anio_id, mes_id: mes_id, ocupacion: ocupacion }

		if (empresa_id == null || tipo_declaracion_id == null || anio_id == null || mes_id == null) {
			this.status = 'error';
			this.disableBtn = false
			$(".declaracion").show();
			this.message_error = 'Favor de seleccionar una opción por cada campo';

			setTimeout(function () {
				$(".declaracion").fadeTo(500, 1).slideUp(500, function () {
					$(".declaracion").hide();
				});
			}, 3000);
		} else {
			$(".loading").show();
			this._declaracionService.createDeclaracion(this.token, info).subscribe(
				response => {
					if (response.status == 'success') {
						$(".loading").hide();

						this.status = response.status;
						this.message_success = response.message;
						let declaracion_id = response.declaracion_id;

						setTimeout(function () {
							location.href = "declaracion/" + declaracion_id;
						}, 3000);

						this._declaracionService.getDeclaraciones(this.token).subscribe(
							response => {
								// Obtener el token 
								if (response.status == 'success') {
									this.declaraciones = response.declaraciones;
									this.empresa = response.empresa;
									//this.rerender();
								}
							},
							error => {
								if (error['status'] == 401) {
									this._router.navigate(['logout/1']);
								} else {
									this.declaraciones = null;
								}
							}
						);
					}
				},
				error => {
					if (error['status'] == 401) {
						this._router.navigate(['logout/1']);
					} else {
						this.disableBtn = false
						$(".loading").hide();
						$(".declaracion").show();
						this.status = 'error';
						this.message_error = error['error']['message'];

						setTimeout(function () {
							$(".declaracion").fadeTo(500, 1).slideUp(500, function () {
								$(".declaracion").hide();
							});
						}, 3000);
					}
				}
			);
		}

	}

	/* rerender(): void {
		this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
			// Destroy the table first
			dtInstance.destroy();
			// Call the dtTrigger to rerender again
			this.dtTrigger.next();
		});
	} */

}
